import { useState } from "react";
import { Monitor, Moon, Sun } from "lucide-react";
import { gespeichertesTheme, themeAnwenden, type Theme } from "../lib/theme";

const OPTIONEN: { value: Theme; label: string; Icon: typeof Sun }[] = [
  { value: "system", label: "System", Icon: Monitor },
  { value: "light", label: "Hell", Icon: Sun },
  { value: "dark", label: "Dunkel", Icon: Moon },
];

/** Drei Zustände in einer Reihe: System, hell, dunkel. */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(gespeichertesTheme);
  return (
    <div className="theme-toggle" role="group" aria-label="Darstellung">
      {OPTIONEN.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          title={label}
          aria-label={label}
          aria-pressed={theme === value}
          onClick={() => { setTheme(value); themeAnwenden(value); }}
        >
          <Icon aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
